import { Typography } from '@mui/material';
import { LayoutGrid, LayoutGridItem } from 'app/layout/LayoutGrid';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { LinearProgressBar } from '../CustomComponents/LinearProgressBar';

const useStyes = makeStyles()(theme => ({
  root: {
    width: '100%',
    height: '70px',
    padding: '0px 10px !important',
    marginLeft: '-8px',
  },
  percentageText: {
    transform: 'translate(0px, 8px)',
    fontSize: '12px !important',
  },
}));

interface ComplicanceCardProps {
  title: string;
  image: string;
  total: number;
  completed: number;
}

export const ComplianceCard = (props: ComplicanceCardProps) => {
  const { title, image, total, completed } = props;
  const { classes } = useStyes();

  const totalPercentage = (completed: number, total: number) => {
    return Math.floor((completed/total) * 100);
  };

  return (
    <LayoutGrid direction="column" className={classes.root}>
      <LayoutGridItem>
        <LayoutGrid justifyContent={'space-between'}>
          <LayoutGridItem>
            <LayoutGrid alignItems={'center'}>
              <LayoutGridItem>
                <img src={image} alt={`${title}-img`} />
              </LayoutGridItem>
              <LayoutGridItem>
                <Typography>{title}</Typography>
              </LayoutGridItem>
            </LayoutGrid>
          </LayoutGridItem>
          <LayoutGridItem alignSelf={'end'}>
            <Typography className={classes.percentageText}>{`${totalPercentage(completed, total)}% Compliant`}</Typography>
          </LayoutGridItem>
        </LayoutGrid>
      </LayoutGridItem>
      <LayoutGridItem>
        <LinearProgressBar 
          value={totalPercentage(completed, total)}
          filledItemscount={completed}
          totalItems={total}
        />
      </LayoutGridItem>
    </LayoutGrid>
  )
}